import { string } from 'prop-types';
import React from 'react';

function Transfer({ fill, ...props }) {
  return (
    <svg
      fill="none"
      height="24"
      stroke={fill}
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.11328 11.4375L3.11328 8.6125C3.11328 7.94946 3.37667 7.31357 3.84551 6.84473C4.31436 6.37589 4.95024 6.1125 5.61328 6.1125L17.6883 6.1125"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path
        d="M20.8882 12.5601V15.3851C20.8882 16.0481 20.6248 16.684 20.156 17.1528C19.6871 17.6217 19.0512 17.8851 18.3882 17.8851H6.31319"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path
        d="M15.7603 9.23755L18.8853 6.11255L15.7603 2.98755"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path
        d="M8.24023 14.7681L5.11523 17.8931L8.24023 21.0181"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
    </svg>
  );
}

Transfer.propTypes = {
  fill: string.isRequired
};

export default Transfer;
